module.exports = __webpack_public_path__ + "static/fonts/OpenSans-Bold.f87c798.woff";


//////////////////
// WEBPACK FOOTER
// ./static/font/OpenSans-Bold.woff
// module id = P2So
// module chunks = 3